import { useQuery } from "@tanstack/react-query";
import type { Article } from "../models";
import { apiInstance } from "../utils/_apiInstance";

export interface GetLegislationArticleResponse {
  documento: {
    id: string;
    titulo: string;
    tipo_doc: string;
    tipo: string;
    categoria: string;
    numero: string;
    data: string;
    nome?: string;
  };
  artigo: Article;
}

export const getLegislationArticleById = async (id: string) => {
  const response = await apiInstance.get<GetLegislationArticleResponse>(
    `pesquisa/legislacao?artigo=${id}`
  );
  return response.data;
};

export const useLegislationArticleByIdQuery = (id: string, enabled = true) =>
  useQuery({
    queryKey: ["get-legislation-article-by-id", id],
    queryFn: async () => getLegislationArticleById(id),
    enabled,
  });
